import { DetailedHTMLProps } from "react"

export default function ImgTag(
  props: DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
) {
  return <img {...props} alt={props.alt} loading="lazy" />
}
